module.exports = __webpack_public_path__ + "gd.svg?51b37f949e3215057da83eba06fc64e2";